
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/influitive-alternative",
      function () {
        return require("private-next-pages/influitive-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/influitive-alternative"])
      });
    }
  